const decoder = 'TextDecoder' in window ? new TextDecoder() : {
    decode: data => {
        const aBytes = new Uint8Array(data);
        let sView = '';
        for (let nPart, nLen = aBytes.length, nIdx = 0; nIdx < nLen; nIdx++) {
            nPart = aBytes[nIdx];
            sView += String.fromCharCode(
                nPart > 251 && nPart < 254 && nIdx + 5 < nLen ?
                    (nPart - 252) * 1073741824 + (aBytes[++nIdx] - 128 << 24) + (aBytes[++nIdx] - 128 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
                : nPart > 247 && nPart < 252 && nIdx + 4 < nLen ?
                    (nPart - 248 << 24) + (aBytes[++nIdx] - 128 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
                : nPart > 239 && nPart < 248 && nIdx + 3 < nLen ?
                    (nPart - 240 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
                : nPart > 223 && nPart < 240 && nIdx + 2 < nLen ?
                    (nPart - 224 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
                : nPart > 191 && nPart < 224 && nIdx + 1 < nLen ?
                    (nPart - 192 << 6) + aBytes[++nIdx] - 128
                : nPart);
        }
        return sView;
    }
};

const PING = 'ech+hb'; // Keep web socket connection open

/**
 * This class provides streaming last price data for stocks
 *
 * Last price data is delayed by 15 minutes & given in the local currency
 * Local currency for a stock can be found by looking at its original currency
 * under FUNDAMENTALS_REUTERS in MySQL.
 */
export default class MarketData {
    constructor() {
        this.tickle = undefined; // Interval that keeps web socket connection open.
        this.ws = undefined;
        this.hasInitialized = false;
    }

    /**
     * Opens marketdata websocket for getting stock prices
     *
     * @param {function} initializedFunction function that is called when websocket first opens
     * @param {function} listenerFunction function that should handle data
     */
    startWebSocket(initializedFunction, listenerFunction) {
        console.debug('Starting web socket...');
        //console.debug(window.location.host + '/portal.proxy/v1/mkt/iserver/marketdata/unsubscribeall');
        //console.debug('wss://' + window.location.host + '/portal.proxy/v1/mkt/ws');
        fetch(window.location.origin + '/portal.proxy/v1/mkt/iserver/marketdata/unsubscribeall')
        // Uncomment this one for local testing
        // fetch('https://ndcdyn.interactivebrokers.com/portal.proxy/v1/mkt/iserver/marketdata/unsubscribeall')
        .then(() => {
            //console.debug('Starting web socket');
            // Uncomment this one for local testing
            // this.ws = new WebSocket("wss://ndcdyn.interactivebrokers.com/portal.proxy/v1/mkt/ws");
            this.ws = new WebSocket('wss://' + window.location.host + '/portal.proxy/v1/mkt/ws');
            this.ws.binaryType = 'arraybuffer';
            this.ws.onopen = e => {
                //console.debug('Web Socket open', e);
                // initializedFunction();
            }
            this.ws.onmessage = e => {
                if (!this.hasInitialized) {
                    this.hasInitialized = true;
                    setTimeout(() => {
                        if (!this.tickle) { //tickle websocket every 20s to keep it open
                            this.tickle = setInterval(() => this.ws.send(PING), 20000);
                        }
                        initializedFunction();
                    }, 500);
                    return;
                }
                listenerFunction(decoder.decode(e.data));
            }
        })
        .catch(err => {
            console.error('Unable to start websocket', err);
        });
    }

    closeWebSocket() {
        console.debug('Closing web socket...');
        if (this.ws) {
            this.ws.close();
        }
        if (this.tickle) {
            clearInterval(this.tickle);
        }
    }

    subscribe(conid) {
        if (!this.isWSOpen()) return;
        // this.ws.send('mds+' + conid + '+{"fields": ["31"]}');
        this.ws.send('smd+' + conid + '+{"fields": ["31"]}');
    }

    unsubscribe(conid) {
        if (!this.isWSOpen()) return;
        // this.ws.send('mdu+' + conid);
        this.ws.send('umd+' + conid);
    }

    isWSOpen() {
        if (!this.ws) return false;
        return this.ws.readyState === this.ws.OPEN;
    }
}
